import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

/**
 * Recuperar lista de clientes registrados al portal
 * @param { string } an8 - identificador del usuario
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Febrero 2024
 */ 
const getRegisterCustomers = async() => {

  const token = await authHeader();
  
  const url = `${ baseUrl }/zone-administrator/list-an8`;
  
  return axios.get(url,
  {headers: token}
  ).then(
      (response) => {
    return response.data;
  })
};

/**
 * Recupera la lista de clientes asociados al administrador
 * @param { string } idAdminZone - identificador del administrador de zona
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Febrero 2024
 */ 

const getAdminZoneClientListByAN8 = async(an8AdminZone) => {

  const token = await authHeader();
  const url = `${ baseUrl }/zone-administrator/client-associates/${an8AdminZone}`;
  
  return axios.get(url,
  {headers: token}
  ).then(
      (response) => {
    return response.data;
  })
};

/**
 * Crea rata de información de zona
 * @param { string } adminData - objeto del administrador de zona
 * @returns {any} recupera la respuesta de la solicitud
 * @param { string } idUser - an8 del usuario administrador
 * @author alSanchez - ETE
 * @version 1.0.0 - Febrero 2024
 */ 
const createAdminZone = async(adminData, idUser) => {
  const token = await authHeader();
  const url = `${ baseUrl }/zone-administrator/assign/${idUser}`;
return axios.post(url, adminData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};

/**
 * Actualiza administrador de zona por id
 * @param { string } adminData - objeto del administrador de zona
 * @param { string } idUser - an8 del usuario administrador
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Febrero 2024
 */ 
const updateAdminZone = async(adminData, idUser) => {
  const token = await authHeader();
  const url = `${ baseUrl }/zone-administrator/update-assignment/${idUser}`;
return axios.put(url, adminData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};


export default {
  getRegisterCustomers,
  getAdminZoneClientListByAN8,
  createAdminZone,
  updateAdminZone
};